import React, { Fragment } from "react";
import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import logo from "./logo.png";
import {
  dateFormat,
  convertTo12Hour,
  dateFormatting,
  convertTimeToDateFormat,
  convertTo12HourFormat,
} from "../utils/Utils";
import { dateFormate } from "../../utils";

const borderColor = "#90e5fc";
const blankRows = Array(3).fill(0);

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: "column",
  },
  logo: {
    width: 200,
    height: 106,
    marginLeft: "auto",
    marginRight: "auto",
  },
  titleContainerName: {
    flexDirection: "row",
    marginTop: -20,
    justifyContent: "center",
    alignItems: "center",
  },
  reportTitleName: {
    color: "black",
    letterSpacing: 0,
    fontSize: 8,
    textAlign: "center",
  },
  invoiceNoContainer: {
    flexDirection: "row",
    marginTop: 36,
    justifyContent: "flex-end",
  },
  invoiceDateContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  invoiceDate: {
    fontSize: 12,
    fontStyle: "bold",
  },
  label: {
    width: 60,
  },
  labelWithRed: {
    width: 60,
    color: "red",
  },
  headerContainer: {
    marginTop: 70,
  },
  billTo: {
    marginTop: 20,
    paddingBottom: 3,
    fontFamily: "Helvetica-Oblique",
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#bff0fd",
  },
  container: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    backgroundColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  description: {
    width: "60%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  itemCol: {
    width: "30%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  itemColHead: {
    width: "20%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  serialNUmber: {
    width: "20%",
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },

  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },

  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontStyle: "bold",
  },
  description: {
    width: "60%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  qty: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    paddingRight: 8,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  amount: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },

  description: {
    width: "85%",
    textAlign: "right",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  total: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
  titleContainer: {
    flexDirection: "row",
    marginTop: 12,
  },
  reportTitle: {
    fontSize: 12,
    textAlign: "center",
    textTransform: "uppercase",
  },
  reportTitleTerms: {
    fontSize: 8,
    textAlign: "center",
  },
  termsAndConditions: {
    marginTop: 20,
    fontSize: 7,
    textAlign: "left",
  },
  bulletList: {
    marginTop: 10,
  },
  listItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  bullet: {
    marginRight: 5,
    fontSize: 10,
  },
  listItemText: {
    fontSize: 7,
  },
  rowA: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
    marginTop: 36,
  },
  columnA: {
    flex: 1, // Make each column take equal space
    marginRight: 10, // Add margin between columns
  },
});

const rows = blankRows.map((x, i) => (
  <View style={styles.row} key={`BR${i}`}>
    <Text style={styles.qty}> </Text>
    <Text style={styles.itemCol}> </Text>
    <Text style={styles.serialNUmber}> </Text>
    <Text style={styles.serialNUmber}> </Text>
    <Text style={styles.qty}> </Text>
    <Text style={styles.amount}> </Text>
  </View>
));

// Create Document Component
// const ReturnPrint = ({
//   products,
//   customerName,
//   address,
//   customerNumber,
//   invoiceId,
//   returnDate,
//   items
// }) => {
//   const productName = (proId) => {
//     let data = products?.filter((data) => data._id === proId);
//     console.log(data);

//     return data?.[0].name;
//   };
//   console.log("items details", items)
//   console.log("Received Props:", { products, customerName, address, customerNumber, invoiceId, returnDate, items });

//   const itemsRow = items?.map((item, index) => (

//     <View style={styles.row} key={index}>

//       <Text style={styles.qty}>{index + 1}</Text>
//       {/* <Text style={styles.itemCol}> {productName(item.product)}</Text> */}

//       <Text style={styles.serialNUmber}>{item?.serialNumber}</Text>

//       {/* <Text style={styles.startdate}>{item.startDate}</Text> */}
//       {/* <Text style={styles.qty}> {item.endDate}</Text> */}
//       {/* <Text style={styles.amount}> {item.amount}</Text>  */}

//     </View>

//   ));
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <Image style={styles.logo} src={logo} />
//         <View style={styles.titleContainerName}>
//           <Text style={styles.reportTitleName}>
//             {' '}
//             Mini Road, Changuvetty , Kottakkal - 9778069953
//           </Text>
//         </View>
//         <View style={styles.rowA}>
//           <View style={styles.columnA}>
//             <Text style={styles.columnText}>
//               {' '}
//               <View style={styles.invoiceNoContainer}>
//                 <Text style={styles.billTo}>Bill To: {'\n'}</Text>

//                 <Text>
//                   {customerName} {'\n'}
//                 </Text>
//                 <Text>
//                   {' '}
//                   {address} {'\n'}{' '}
//                 </Text>
//                 <Text> {customerNumber} </Text>
//               </View>
//             </Text>
//           </View>
//           <View style={styles.columnA}>
//             <Text style={styles.columnText}></Text>
//           </View>
//           <View style={styles.columnA}>
//             <Text style={styles.columnText}>
//               {' '}
//               <Fragment>
//                 <View style={styles.invoiceNoContainer}>
//                   <Text style={styles.label}>Invoice No:</Text>
//                   <Text style={styles.invoiceDate}>
//                     {`ADC_${invoiceId}`} {'\n'}
//                   </Text>
//                 </View>
//                 <View style={styles.invoiceDateContainer}>
//                   <Text style={styles.label}>Date: </Text>
//                   <Text>{returnDate}</Text>
//                 </View>
//               </Fragment>
//             </Text>

//             <Text style={styles.columnText}>
//               {' '}
//               <View style={styles.invoiceDateContainer}>
//                 <Text style={styles.labelWithRed}>Return </Text>
//               </View>
//               <View style={styles.invoiceDateContainer}>
//                 <Text style={styles.label}>Time: </Text>
//                 <Text style={styles}>
//                   {dateFormat(items[0]?.created)}{' '} </Text>
//               </View>
//             </Text>
//           </View>
//         </View>

//         <View style={styles.tableContainer}>
//           <View style={styles.container}>
//             <Text style={styles.qty}>No</Text>
//             <Text style={styles.itemColHead}>Item</Text>
//             <Text style={styles.serialNUmber}>S No</Text>
//             <Text style={styles.serialNUmber}>Start Date</Text>
//             <Text style={styles.qty}>End Date</Text>
//             <Text style={styles.amount}>Amount</Text>
//           </View>
//           {/* <Fragment>{itemsRow}</Fragment> */}
//           <Fragment>{rows}</Fragment>
//           <View style={styles.row}>
//             {/* <Text style={styles.description}>TOTAL</Text> */}
//             {/* <Text style={styles.total}> {amount}</Text> */}
//           </View>
//           <View style={styles.row}>
//             {/* <Text style={styles.description}>Advance</Text> */}
//             {/* <Text style={styles.total}> {advance}</Text> */}
//           </View>
//           <View style={styles.row}>
//             {/* <Text style={styles.description}>Discount</Text> */}
//             {/* <Text style={styles.total}> {discount}</Text> */}
//           </View>
//           <View style={styles.row}>
//             {/* <Text style={styles.description}>Balance</Text> */}
//             <Text style={styles.total}>
//               {' '}
//               {/* {amount - (parseInt(advance) + parseInt(discount))} */}
//             </Text>
//           </View>
//         </View>
//         <View style={styles.titleContainer}>
//           <Text style={styles.reportTitle}>Thank you for your business</Text>{' '}
//         </View>
//         <View style={styles.titleContainer}>
//           <Text style={styles.reportTitleTerms}> Terms & Conditions</Text>
//         </View>
//         <View style={styles.listItem}>
//           <Text style={styles.bullet}>•</Text>
//           <Text style={styles.listItemText}>
//             {' '}
//             It only issue or damage is loud in the returned product the client
//             should give additional expenditure
//           </Text>
//         </View>
//         <View style={styles.listItem}>
//           <Text style={styles.bullet}>•</Text>
//           <Text style={styles.listItemText}>
//             {' '}
//             * data lost by any technical issue we will not take the
//             responsibility
//           </Text>
//         </View>
//         <View style={styles.listItem}>
//           <Text style={styles.bullet}>•</Text>
//           <Text style={styles.listItemText}>
//             {' '}
//             * in case Returning time will extend the customer should inform the
//             office staff other wise customer shoald pay an extra charge
//           </Text>
//         </View>
//       </Page>
//     </Document>
//   );
// };
const ReturnPrint = ({
  products,
  customerName,
  address,
  customerNumber,
  invoiceId,
  returnDate,
  items,
  amountDetails,
  returnData,
}) => {
  const productName = (proId) => {
    let data = products?.filter((data) => data._id === proId);
    console.log(data);
    return data?.[0]?.name;
  };

  console.log("items details", typeof items[0]?.returnOn);
  console.log(items);
  let returntime = items[0]?.returnOn;
  console.log("Received Props:", {
    products,
    customerName,
    address,
    customerNumber,
    invoiceId,
    returnDate,
    returntime,
    items,
    amountDetails,
  });
  console.log("returnData", returnData);

  const itemsRow = items?.map((item, index) => (
    <View style={styles.row} key={index}>
      <Text style={styles.qty}>{index + 1}</Text>
      <Text style={styles.itemColHead}>{productName(item.product)}</Text>
      <Text style={styles.serialNUmber}>{item?.serialNumber}</Text>
      <Text style={styles.serialNUmber}> {dateFormatting(item.startDate)}</Text>
      <Text style={styles.serialNUmber}>
        {"\t"}
        {dateFormatting(item.endDate)}
      </Text>

      {/* <Text style={styles.amount}>{(returnDate[0]?.returnAt)}</Text> */}
      <Text style={styles.serialNUmber}>{item.amount}</Text>
    </View>
  ));

  let totalAmountFromOrder = amountDetails?.totalAmount || 0;
  let receive = amountDetails?.received || 0;
  let discount = amountDetails?.returnDiscount || 0;
  let balance = amountDetails?.finalBalance || 0;


  const convertTo12Hr = (timeStr) => {
    if (!timeStr) return "";

    if (
      timeStr.toLowerCase().includes("am") ||
      timeStr.toLowerCase().includes("pm")
    ) {
      return timeStr;
    }

    const timeParts = timeStr.split(":");
    let hours = parseInt(timeParts[0]);
    const minutes = timeParts[1] || "00";
    const seconds = timeParts[2] || "00";

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${hours}:${minutes} ${ampm}`;
  };

  const getReturnDateTime = () => {
    if (returnData && returnData.length > 0 && returnData[0]?.returnAt) {
      const time =
        returnData[0].returnOn || convertTo12HourFormat(returnData[0].returnAt);
      return {
        date: dateFormatting(returnData[0].returnAt),
        time: convertTo12Hr(time),
      };
    }

    if (items && items.length > 0 && items[0]?.returnOn) {
      return {
        date: dateFormatting(items[0].returnOn),
        time: convertTo12Hr(items[0].returnOn),
      };
    }

    const now = new Date();
    return {
      date: returnDate ? dateFormatting(returnDate) : now.toLocaleDateString(),
      time: now.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      }),
    };
  };

  const returnDateTime = getReturnDateTime();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.logo} src={logo} />
        <View style={styles.titleContainerName}>
          <Text style={styles.reportTitleName}>
            Mini Road, Changuvetty, Kottakkal - 9778069953
          </Text>
        </View>
        <View style={styles.rowA}>
          <View style={styles.columnA}>
            <Text style={styles.columnText}>
              <View style={styles.invoiceNoContainer}>
                <Text style={styles.billTo}>Bill To: {"\n"}</Text>
                <Text>
                  {customerName} {"\n"}
                </Text>
                <Text>
                  {address} {"\n"}
                </Text>
                <Text>{customerNumber}</Text>
              </View>
            </Text>
          </View>
          <View style={styles.columnA}></View>
          <View style={styles.columnA}>
            <Text style={styles.columnText}>
              <Fragment>
                <View style={styles.invoiceNoContainer}>
                  <Text style={styles.label}>Invoice No:</Text>
                  <Text style={styles.invoiceDate}>
                    {`ADC_${invoiceId}`} {"\n"}
                  </Text>
                </View>
                <View style={styles.invoiceDateContainer}>
                  {" "}
                  <View style={styles.invoiceDateContainer}>
                    <Text style={styles.labelWithRed}>Return </Text>
                  </View>
                  <Text style={styles.label}> Date: </Text>
                  <Text>{returnDateTime.date}</Text>
                </View>
                <View style={styles.invoiceDateContainer}>
                  <Text style={styles.label}>Status: </Text>
                  <Text>Returned</Text>
                </View>
                {/* <Text style={styles.columnText}>
                  <View style={styles.invoiceDateContainer}>
                    <Text style={styles.label}>Return Date: </Text>
                    <Text>{dateFormatting(returnData[0]?.returnAt)}</Text>
                  </View>
                </Text> */}
              </Fragment>
            </Text>
            <Text style={styles.columnText}>
              {" "}
              <View style={styles.invoiceDateContainer}>
                <Text style={styles.labelWithRed}>Return </Text>
              </View>
              <View style={styles.invoiceDateContainer}>
                <Text style={styles.label}>Time: </Text>
                <Text style={styles}>{returnDateTime.time}</Text>
              </View>
            </Text>
          </View>
        </View>
        <View style={styles.tableContainer}>
          <View style={styles.container}>
            <Text style={styles.qty}>No</Text>
            <Text style={styles.serialNUmber}>Item</Text>
            <Text style={styles.serialNUmber}>S No</Text>
            <Text style={styles.serialNUmber}>StartDate</Text>
            <Text style={styles.serialNUmber}>EndDate</Text>
            {/* <Text style={styles.serialNUmber}>ReturnAt </Text> */}
            <Text style={styles.serialNUmber}>Amount</Text>
          </View>
          <Fragment>{itemsRow}</Fragment>
          <View style={styles.row}>
            <Text style={styles.description}>TOTAL Amount</Text>
            <Text style={styles.total}>{totalAmountFromOrder.toFixed(2)}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Receive</Text>
            <Text style={styles.total}>{receive}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Discount</Text>
            <Text style={styles.total}>{discount}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.description}>Balance</Text>
            <Text style={styles.total}>{balance}</Text>
          </View>
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitle}>Thank you for your business</Text>
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.reportTitleTerms}>Terms & Conditions</Text>
        </View>
        <View style={styles.listItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.listItemText}>
            If any issue or damage is found in the returned product, the client
            should bear additional expenditure.
          </Text>
        </View>
        <View style={styles.listItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.listItemText}>
            * In case of data loss due to any technical issue, we will not take
            responsibility.
          </Text>
        </View>
        <View style={styles.listItem}>
          <Text style={styles.bullet}>•</Text>
          <Text style={styles.listItemText}>
            * If the returning time extends, the customer should inform the
            office staff; otherwise, the customer should pay an extra charge.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReturnPrint;
